export default "__VITE_ASSET__D1fH7aJr__"